// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3CsO-","body":"style_body__KljNw"};